import { db } from '../firebase';
import { 
  collection, 
  doc, 
  setDoc, 
  deleteDoc, 
  getDocs, 
  query, 
  where,
  updateDoc,
  serverTimestamp,
  onSnapshot,
  Timestamp 
} from 'firebase/firestore';

export const taskService = {
  subscribeToTasks(userId, callback) {
    const tasksRef = collection(db, 'tasks');
    const q = query(tasksRef, where('userId', '==', userId));
    
    return onSnapshot(q, (snapshot) => {
      const tasks = {
        backlog: [],
        inProgress: [],
        inReview: [],
        completed: []
      };

      snapshot.forEach((doc) => {
        const data = doc.data();
        const task = { 
          id: doc.id,
          ...data,
          createdAt: data.createdAt instanceof Timestamp ? data.createdAt.toDate() : 
                     data.createdAt ? new Date(data.createdAt) : new Date(),
          updatedAt: data.updatedAt instanceof Timestamp ? data.updatedAt.toDate() : 
                     data.updatedAt ? new Date(data.updatedAt) : new Date(),
          dueDate: data.dueDate instanceof Timestamp ? data.dueDate.toDate() : 
                   data.dueDate ? new Date(data.dueDate) : null
        };
        tasks[task.status || 'backlog'].push(task);
      });

      // Sort tasks by dueDate first (if exists), then by createdAt
      Object.keys(tasks).forEach(status => {
        tasks[status].sort((a, b) => {
          if (a.dueDate && b.dueDate) return a.dueDate - b.dueDate;
          if (a.dueDate) return -1;
          if (b.dueDate) return 1;
          return b.createdAt - a.createdAt;
        });
      });

      callback(tasks);
    });
  },

  async createTask(userId, taskData) {
    try {
      const taskRef = doc(collection(db, 'tasks'));
      const now = serverTimestamp();
      const task = {
        userId,
        status: 'backlog',
        title: taskData.text,
        description: taskData.description || '',
        dueDate: taskData.dueDate ? Timestamp.fromDate(new Date(taskData.dueDate)) : null,
        importance: taskData.importance,
        createdAt: now,
        updatedAt: now
      };

      await setDoc(taskRef, task);
      
      // Return task with local timestamps for immediate UI update
      return { 
        id: taskRef.id, 
        ...task,
        createdAt: new Date(),
        updatedAt: new Date(),
        dueDate: taskData.dueDate ? new Date(taskData.dueDate) : null
      };
    } catch (error) {
      console.error('Error creating task:', error);
      throw error;
    }
  },

  async updateTask(taskId, updates) {
    try {
      const taskRef = doc(db, 'tasks', taskId);
      const updateData = { ...updates };

      // Convert any date fields to Firestore Timestamps
      if (updates.dueDate) {
        updateData.dueDate = Timestamp.fromDate(new Date(updates.dueDate));
      }
      
      await updateDoc(taskRef, {
        ...updateData,
        updatedAt: serverTimestamp()
      });
    } catch (error) {
      console.error('Error updating task:', error);
      throw error;
    }
  },

  async updateTaskStatus(taskId, status) {
    return this.updateTask(taskId, { status });
  },

  async deleteTask(taskId) {
    try {
      await deleteDoc(doc(db, 'tasks', taskId));
    } catch (error) {
      console.error('Error deleting task:', error);
      throw error;
    }
  }
}; 